

<!------------ START TEMPLATE ------------>
<template>
  <div
    v-if="exibir == true"
    id="data-list-list-view"
    class="data-list-container"
  >
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="closeSideBar"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @concluido="concluido"
      :key="chave"
    />

    <vs-table
      noDataText="Nenhum Chamado Encontrado"
      class="tablePrincipal"
      ref="table"
      multiple
      v-model="selected"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START ADD NOVO CHAMADO ------------>
          <div
            class="
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-between
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="openSideBar({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Chamado</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO Proposta ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{ itens.length }} de {{ qtdTotal }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA Proposta ------------>

      <template slot="thead">
        <vs-th sort-key="Nome">Descrição</vs-th>
        <!--<vs-th sort-key="Status">Data</vs-th>-->
        <vs-th sort-key="Usuario">Setor</vs-th>
        <!--vs-th sort-key="Usuario">Mensagem</vs-th-->
        <vs-th sort-key="Status">Status</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      <!------------ END TITULO DA Proposta ------------>

      <!------------ START Proposta ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">
                {{ tr.assunto }}
                <br />
                {{ tr.mensagem }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category" v-if="tr.Chamado_domSetor">
                {{ tr.Chamado_domArea.nomeArea }}
                <br />
                {{ tr.Chamado_domSetor.nomeSetor }}
              </p>
            </vs-td>
            <vs-td>
              <p>
                <vs-chip
                  :color="
                    getStatusColor(tr.Chamado_domStatusChamado.nomeStatus)
                  "
                  class="product-order-status"
                  >{{ tr.Chamado_domStatusChamado.nomeStatus }}</vs-chip
                >
                <vs-chip
                  v-if="
                    vistoria == true &&
                    tr.Chamado_domStatusChamado.nomeStatus != 'Finalizado'
                  "
                  :color="
                    getStatusColorHoras(
                      tr.Chamado_domStatusChamado.nomeStatus,
                      tr.updatedAt
                    )
                  "
                >
                  <feather-icon
                    icon="ClockIcon"
                    class="mr-2"
                    svgClasses="stroke-current w-6 h-6"
                  />
                  {{
                    calculaQtddeDiasEnviada(
                      tr.Chamado_domStatusChamado.nomeStatus,
                      tr.updatedAt
                    )
                  }}
                </vs-chip>
              </p>
            </vs-td>
            <vs-td>
              <p class="product-price text-center">
                <vs-button
                  radius
                  v-tooltip="'Detalhes'"
                  color="primary"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-list"
                  class="d-inline"
                  @click="opemModal(tr.idChamado)"
                ></vs-button>
                <router-link
                  :to="`editarChamado/${tr.idChamado}`"
                  v-if="tr.Chamado_domStatusChamado.idStatusChamado == 2"
                >
                  <vs-button
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                    radius
                    v-tooltip="'Editar'"
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                  ></vs-button>
                </router-link>
                <vs-button
                  radius
                  v-tooltip="'Finalizar'"
                  color="warning"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-check"
                  class="d-inline"
                  @click="confirmFinaliza(tr)"
                  v-if="$can('Finalizar Chamado', subjectPermission)"
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination :total="qtdPaginas" v-model="paginaAtual"></vs-pagination>
    <!------------ END Proposta ------------>

    <!------------ START INFORMAÇÕES Da Ouvidoria ------------>
    <vs-popup
      class="holamundo"
      :title="'Finalizar Chamado'"
      :active.sync="popupFinaliza"
      @close="closeFinaliza"
    >
      <vs-list>
        <vs-list-header
          title="Deseja Finalizar o Chamado?"
          color="gray"
        ></vs-list-header>
        <vs-list-item>
          <vs-button @click.stop.prevent="closeFinaliza()" color="danger" type="border"
            >Cancelar</vs-button
          >
          <vs-button
            style="margin-left: 10px"
            @click="finalizaChamado()"
            color="success"
            type="filled"
            >Confirmar</vs-button
          >
        </vs-list-item>
      </vs-list>
    </vs-popup>

    <vs-popup
      v-if="modalSelecionado"
      class="holamundo"
      :title="'Detalhes Chamado ' + modalSelecionado.chamado.idChamado"
      :active.sync="popupActive"
      @close="closeDetalhes"
    >
      <vs-list>
        <vs-list-item icon="person" title="Informações">
          <p>{{ modalSelecionado.chamado.Chamado_Usuario.nome }}</p>
          <p>{{ modalSelecionado.chamado.Chamado_Usuario.email }}</p>
        </vs-list-item>
        <vs-list-item icon="apartment" title="Área / Setor">
          <p>
            {{ modalSelecionado.chamado.Chamado_domArea.nomeArea }} /
            {{ modalSelecionado.chamado.Chamado_domSetor.nomeSetor }}
          </p>
        </vs-list-item>
        <vs-list-item icon="date_range" title="Data de Criação">
          <p>{{ formataData(modalSelecionado.chamado.createdAt) }}</p>
        </vs-list-item>
        <vs-list-item icon="forum" title="Assunto" style="overflow: auto">
          <div style="padding-left: 10%">
            {{ modalSelecionado.chamado.assunto }}
          </div>
        </vs-list-item>
        <vs-list-item icon="forum" title="Mensagem" style="overflow: auto">
          <div style="padding-left: 10%">
            {{ modalSelecionado.chamado.mensagem }}
          </div>
        </vs-list-item>
        <vs-list-item
          icon="forum"
          title="Imagens"
          style="overflow: auto"
          v-if="modalSelecionado.chamado.files.length > 0"
        >
          <div
            style="display: inline-flex"
            @click="openFile(modalSelecionado.chamado.files)"
          >
            <img
              :src="file.arquivo"
              v-for="file in modalSelecionado.chamado.files"
              :key="file.idArquivo"
              width="50"
              height="50"
            />
          </div>
        </vs-list-item>
      </vs-list>
      <hr class="my-2" />
      <h5 class="mb-6">
        {{
          modalSelecionado.respostas.length > 0
            ? modalSelecionado.respostas.length == 1
              ? modalSelecionado.respostas.length + " Resposta"
              : modalSelecionado.respostas.length + " Respostas"
            : "Sem Respostas"
        }}
      </h5>
      <vs-list
        v-for="item in modalSelecionado.respostas"
        :key="item.idResposta"
      >
        <vs-list-header
          icon-pack="feather"
          icon="icon-users"
          :title="item.autor"
        ></vs-list-header>
        <vs-list-item
          icon="reply"
          title="Resposta  "
          v-bind:subtitle="formataData(item.createdAt)"
          style="overflow: auto"
        >
          {{ item.resposta }}
        </vs-list-item>
        <vs-list-item
          icon="forum"
          title="Imagens"
          style="overflow: auto"
          v-if="item.files.length > 0"
        >
          <div style="display: inline-flex" @click="openFile(item.files)">
            <img
              :src="file.arquivo"
              v-for="file in item.files"
              :key="file.idArquivo"
              width="50"
              height="50"
            />
          </div>
        </vs-list-item>
      </vs-list>
    </vs-popup>

    <!------------ END INFORMAÇÕES DO Proposta ------------>
    <vs-popup
      class="holamundo"
      :title="'Detalhes Arquivo'"
      :active.sync="popupFile"
      @close="closeFile"
    >
      <vs-list v-if="popupFile == true">
        <div class="carousel-example">
          <swiper :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
            <swiper-slide v-for="file in popupFiles" :key="file.idArquivo">
              <img class="responsive" :src="file.arquivo" alt="banner" />
            </swiper-slide>
          </swiper>
        </div>
      </vs-list>
    </vs-popup>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from "./../Includes/SideBar";
import service from "../../services";
import downloadexcel from "vue-json-excel";
import ModalInfo from "../../components/ModalInfo";
import moment from "moment";

import jwt from "jsonwebtoken";
import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
    swiper,
    swiperSlide,
  },
  props: ["filtro", "realizaFiltro", "vistoria", "subjectPermission"],
  watch: {
    realizaFiltro: function (newValue, oldValue) {
      if (newValue == true) {
        // console.log(this.filtro);
        this.buscaDados();
        this.$emit("filtroOk", true);
      }
    },
    paginaAtual: function (newValue, oldValue) {
      // console.log(this.paginaAtual);
      this.buscaDados();
    },
    itemsPerPage: function (newValue, oldValue) {
      // console.log(this.itemsPerPage);
      this.buscaDados();
    },
  },
  data() {
    return {
      chave: 0,
      isAdmin: false,
      idEmpresa: null,
      dadosSideBar: {},
      controllerGeral: "Chamado",
      formSideBar: "Chamado",
      entidade: "Chamado",
      titleSideBar: "Adicionar Chamado",
      popupActive: false,
      popupFinaliza: false,
      chamadoSelecionado: {},
      modalSelecionado: null,
      selected: [],
      itens: [{ Chamado_domSetor: {} }],
      colunas: {},
      itemsPerPage: 25,
      paginaAtual: 1,
      qtdTotal: 0,
      qtdPaginas: 0,
      isMounted: false,
      addNewDataSidebar: false,
      exibir: false,
      popupFile: false,
      popupFiles: [],
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  methods: {
    verificaAdmin() {
      const token = localStorage.getItem("user-token");
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil == "Super User") this.isAdmin = true;
      }
    },
    calculaQtddeDiasEnviada(status, date) {
      var a = moment();
      var horas = a.diff(date, "hours");
      return horas + "h aguardando";
    },
    getStatusColorHoras(status, date) {
      var a = moment();
      var horas = a.diff(date, "hours");
      if (horas < 10) return "success";
      if (horas >= 10 && horas <= 24) return "warning";
      if (horas > 24) return "danger";
    },

    buscaDados() {
      this.selected = [];
      this.$vs.loading();
      var objSend = {};
      if (this.filtro) {
        objSend = { ...this.filtro };
        // objSend.dataInicial = moment(this.filtro.dataInicial).format(
        //   "YYYY-MM-DD"
        // );
        // objSend.dataFinal = moment(this.filtro.dataFinal).format("YYYY-MM-DD");
      } else {
        // objSend.dataInicial = moment()
        //   .add(-30, "days")
        //   .format("YYYY-MM-DD");
        // objSend.dataFinal = moment().format("YYYY-MM-DD");
      }

      objSend.pagina = this.paginaAtual;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;

      service
        .post("Chamado", "listarChamadosFiltro", objSend)
        .then((res) => {
          this.exibir = true;
          this.itens = [];
          // console.log(res.data);
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;

          if (this.qtdPaginas % 1 != 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);

          if (this.qtdTotal > 0) {
            res.data.chamados.forEach((element) => {
              this.itens.push(element);
            });
          }

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    concluido() {
      this.chave++;
      this.buscaDados();
    },
    getStatusColor(data) {
      if (data == "Aguardando Relator") return "warning";
      if (data == "Finalizado") return "success";
      return "danger";
    },
    openFile(files) {
      this.popupFiles = files;
      this.popupFile = true;
    },
    closeFile() {
      this.popupFile = false;
    },
    confirmFinaliza(chamado) {
      this.popupFinaliza = true;
      this.chamadoSelecionado = chamado;
    },
    finalizaChamado() {
      this.$vs.loading();
      console.log(this.chamadoSelecionado);
      service
        .post("Chamado", "finalizarChamado", {
          idChamado: this.chamadoSelecionado.idChamado,
          idEmpresa: null,
        })
        .then((res) => {
          this.closeFinaliza();
          this.$vs.loading.close();
          this.buscaDados();
          this.$vs.notify({
            position: "top-center",
            title: "Obrigado",
            text: "Seu Chamado foi Finalizado!",
            color: "success",
          });
        });
    },
    opemModal(cod) {
      this.$vs.loading();
      this.popupActive = true;
      service
        .post("Chamado", "listarRespostasChamado", { idChamado: cod })
        .then((res) => {
          this.modalSelecionado = res.data;
          this.modalSelecionado.chamado.files = res.data.files.filter(
            (file) => {
              return !file.idResposta;
            }
          );
          this.modalSelecionado.respostas.forEach((element) => {
            element.files = res.data.files.filter((file) => {
              return file.idResposta == element.idResposta;
            });
          });
          this.$vs.loading.close();
        });
    },
    openSideBar(dados) {
      dados.idProposta == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    closeDetalhes() {
      this.popupActive = false;
      this.modalSelecionado = null;
    },
    closeFinaliza() {
      this.popupFinaliza = false;
    },
    closeSideBar() {
      this.addNewDataSidebar = false;
      this.chave++;
    },
    formataData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },
  },
  created() {},
  mounted() {
    this.buscaDados();
    this.verificaAdmin();
    // this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>


<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}
</style>

<!------------ END STYLE ------------>
